import { Component, OnInit } from '@angular/core';
import { NewPageList } from '../../core/models/new-page-list';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import * as firebase from 'firebase/app';
import { Constants } from '../../core/config/Constants';
import { MultiUtilityService } from '../../core/services/multi-utility.service';
import { MultiUtility } from '../../shared/multi-utility';
import { ActivatedRoute } from '@angular/router';
import { NewPagePref } from '../../core/models/new-page-prefs';

@Component({
  selector: 'app-youtube-video',
  templateUrl: './youtube-video.component.html',
  styleUrls: ['./youtube-video.component.css'],
  providers: [NewPageService, MultiUtilityService]
})
export class YoutubeVideoComponent implements OnInit {

  aboutUs: NewPageList;
  urlClass = 'form-control';
  _ref: any;
  eventYouTubeVideo: boolean = true;

  fileURL: string;
  eventId: string;

  constructor(private newPageService: NewPageService, private multiUtilityService: MultiUtilityService, private route: ActivatedRoute) {
    this.newPageService.validate$.subscribe(validate => {
      if (validate) {
        this.validate();
      }
    });
  }

  ngOnInit() {

    if (this.aboutUs.aboutPrefs != undefined && this.aboutUs.aboutPrefs.youtubeCustomImageCMId != undefined) {
      this.multiUtilityService.getContentsCMByID(this.aboutUs.aboutPrefs.youtubeCustomImageCMId, this.eventId).subscribe((contentM) => {
        this.multiUtilityService.getFileURL(contentM, this.eventId).then((url) => {
          this.fileURL = url;
        });
      });
    }

  }

  remove() {
    this._ref.destroy();
    this.newPageService.removeItem(this.aboutUs);
  }

  upItem() {
    this.newPageService.upItem(this.aboutUs);
  }

  downItem() {
    this.newPageService.downItem(this.aboutUs);
  }

  validate() {
    if (this.aboutUs.url == null || this.aboutUs.url.trim().length < 1) {
      this.urlClass = 'form-control fieldWithErrors';
    } else {
      this.urlClass = 'form-control';
    }

  }
  bannerImageFile: File = null;
  // aa:string;
  uploadImage(event): void {
    this.bannerImageFile = event.files[0];
    if (this.aboutUs.aboutPrefs === undefined) {
      this.aboutUs.aboutPrefs = new NewPagePref();
    }
    this.multiUtilityService.uploadImageToStorage2(this.bannerImageFile, firebase, this.eventId, Constants.CONTENT_M_TYPE_OTHERS, this.aboutUs.aboutPrefs.youtubeCustomImageCMId).subscribe(key => { this.aboutUs.aboutPrefs.youtubeCustomImageCMId = key; });
    //   .subscribe(key => {
    //     this.aboutUs.aboutPrefs.youtubeCustomImageCMId = key;
    //     console.log("this.aboutUs.aboutPrefs" + this.aboutUs.aboutPrefs.youtubeCustomImageCMId);
    //   }
    // );

    // this.aboutUs.aboutPrefs.youtubeCustomImageCMId = "sdfdsfds";
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/youtube-video/youtube-video.component.ts